<div class="accordion-item">
    <h2 class="accordion-header" id="headingBegiftigde">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseBegiftigde" aria-expanded="false" aria-controls="collapseBegiftigde">
            Begiftigde
        </button>
    </h2>
    <div id="collapseBegiftigde" class="accordion-collapse collapse" aria-labelledby="headingBegiftigde"
         data-bs-parent="#accordionExample">
        <div class="accordion-body">
            De begiftigde is de ontvanger van de schenking. Voor de Nederlandse schenkbelasting is de begiftigde de
            belastingplichtige. De woonplaats van de begiftigde is relevant bij grensoverschrijdende situaties. Als de
            begiftigde in Nederland woont op het moment van de schenking, is de schenking in beginsel belast, ongeacht
            waar de schenker woont of het vermogen zich bevindt.
            <div class="space20"></div>
            De aangifte moet in principe door de begiftigde worden
            ingediend, tenzij sprake is van een notariële akte die door de notaris wordt verwerkt.
        </div>
    </div>
</div>
